'use client'

import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "../Button";
import Title from "@/components/Title";
import {toast} from "react-toastify";
import {useForm} from "react-hook-form";
import axios from "axios";
import {Loader} from "@/components/Loader";
import {hover, primary, whites} from "@/styles/globalStyleVars";



const ContactForm = ({data}) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }, [])


    const { register, handleSubmit, formState, reset } = useForm({ mode: 'all' });
    const { errors ,isSubmitSuccessful} = formState;

    const success = (msg) => toast.success(msg, {
        position: "top-right", autoClose: 4000, closeOnClick: true, progress: undefined,
    });

    const error = (msg) => toast.error(msg, {
        position: "top-right", autoClose: 4000, closeOnClick: true, progress: undefined,
    });

    const onSubmit = async (data) => {
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append('name', data?.name);
            formData.append('email', data?.email);
            formData.append('phone', data?.phone);
            formData.append('message', data?.message);
            formData.append('form_id', 'contact-form');

            const response = await axios.post('https://cms.shantaequity.net/api/post-req-data/form-submit', formData);
            if (response.status === 200) {
                success('Form submitted successfully')
                console.log(response);

                reset(); // Reset form fields
            } else {
                error('Failed to submit form. Please try again later.');
                console.log(response);

            }
        } catch (err) {
            error('Failed to submit form. Please try again later.');
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {
        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };

    return (

        <StyledListWithForm className={'pt-100 pb-100 contact-form'}>
            {/*{ isSubmitting && <Loader/>}*/}
            <Container>
                <Row>
                    <Col md={{span:6,offset:3}}>
                        <Title text={`Get in <span>Touch!</span>`} color={'#FFF'} margin={'0 0 40px 0'} spancolor={primary}/>
                        <Form className={'form_wrapper contact-us'} onSubmit={handleSubmit(onSubmit)}>
                            <input name={'spam_protector'} type='hidden'/>
                            <input name={'form_id'} value={'contact-form'} type='hidden'/>
                            <div className="form-group">
                                <Form.Group controlId="formBasicName">
                                    <Form.Control
                                        className={errors?.name ? 'has-error form-control-lg' : 'form-control-lg'}
                                        {...register("name", {
                                            required: 'Please enter your name',
                                            pattern: {
                                                value: /^[A-Za-z ]+$/,
                                                message: 'Name must contain only letters',
                                            },
                                        })}
                                        type="name"
                                        placeholder="Name*"
                                    />
                                </Form.Group>
                                {errors.name && <span className="error-message">{errors.name.message}</span>}

                            </div>
                            <div className="form-group">
                                <Form.Group controlId="formBasicPhone">

                                    <Form.Control
                                        className={errors?.phone ? 'has-error form-control-lg' : 'form-control-lg'}
                                        {...register("phone", {
                                            required: 'Please enter your phone number',
                                            pattern: {
                                                // value: /^01[0-9]{9}$/,
                                                value: /^[0-9]*$/,
                                                message: 'Please enter a valid phone number',
                                            },
                                        })}
                                        type="text"
                                        placeholder="Mobile Number*"/>
                                    {errors.phone && <span className="error-message">{errors.phone.message}</span>}
                                </Form.Group>
                            </div>
                            <div className="form-group">
                                <Form.Group controlId="formBasicEmail">

                                    <Form.Control
                                        className={errors?.email ? 'has-error form-control-lg' : 'form-control-lg'}
                                        {...register("email", {
                                            required: 'Please enter your email',
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: 'Please enter a valid email address',
                                            },
                                        })}
                                        type="email"
                                        placeholder="Email Address*"/>
                                    {errors.email && <span className="error-message">{errors.email.message}</span>}

                                </Form.Group>
                            </div>
                            <div className="form-group">
                                <Form.Group controlId="formBasicMessage">

                                    <Form.Control
                                        className={errors?.message?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                        {...register("message", {
                                            required: {
                                                // value:true,
                                                message: 'please enter your message'
                                            },
                                        })}
                                        as="textarea"
                                        rows={2}
                                        placeholder="Message"/>
                                </Form.Group>
                            </div>

                            <div className={`form-group width-fit`}>
                                <div onClick={handleSubmit(onSubmit, onError)}>
                                    <Button submit
                                            text={'Submit'}
                                            background={primary}
                                            hoverBackground={hover}
                                            hovercolor={whites}
                                            hoverborder={'1px solid #638297'}
                                    />
                                </div>

                            </div>

                        </Form>
                    </Col>
                </Row>
            </Container>
            <img data-speed={"clamp(1.2)"} className={'logo-mask'} src="/images/static/shanta-logo-mask.svg" alt=""/>
        </StyledListWithForm>
    )
};

const StyledListWithForm = styled.div`
    background-color: #3C3C3B;
    position: relative;
    
    .logo-mask{
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .form_wrapper {
        height: 100%;


        form {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-between;
        }

        .title {
            font-size: 24px;
            font-weight: 4000;
            line-height: 28px;
            color: #F9F9F9;
            margin: 0 0 40px;
        }

        .form-group {
            margin-bottom: 30px;

            &:last-child {
                margin-bottom: 0;
            }
            .form-label{
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
                color: #000;
                opacity: 0.5;
            }

            .form-control {
                box-shadow: none;
                outline: 0;
                border-radius: 0;
                background: transparent;
                height: auto;
                border-bottom: 1px solid #C6C6C6;
                color: #FFFFFF;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                padding-bottom: 15px;
                margin-bottom: 40px !important;
                &:focus {
                    border-bottom: 1px solid #C6C6C6;
                }

                &::placeholder {
                    color: #C6C6C6;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                }
            }

            textarea {
                min-height: 80px;
                max-height: unset !important;
            }
        }


        .filter__placeholder {
            color: #C4C4C4;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
        }

        .filter__control {
            height: 30px !important;
            padding: 0 !important;
            background: transparent !important;
            border-left: none !important;
            border-right: none !important;
            border-top: none !important;
            

            .filter__single-value {
                color: #C4C4C4 !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                line-height: 20px !important;
            }

            .filter__indicator-separator {
                display: none;
            }

            .filter__value-container {
                padding: 0;
            }

            .filter__dropdown-indicator, .filter__input-container, .filter__placeholder {
                margin: 0;
            }
        }
    }

    @media (max-width: 767px) {

        .form_wrapper {
            padding: 0 15px;
            margin-top: 0px;
        }

        .form_wrapper {
            padding-left: 0;
            padding-right: 0;
        }
    }
    
    .width-fit{
        div{
            width: fit-content;
        }
    }
    
`;

export default ContactForm;
